import { createPieChart } from "./vega_chart_helpers";

$(document).on('turbolinks:load', function() {
  createPieChart(".vegaPieChart");
});
